export default __webpack_public_path__ + "static/media/Header-2-scaled.84d82da0.jpg";